export const STANDARD_LABELS = {
  // ── Grade 3 ───────────────────────────────────────────────────────────────
  'TA-3-CT-001': 'Decomposition',
  'TA-3-CT-004': 'Pattern Recognition',
  'TA-3-CT-007': 'Document Plans',
  'TA-3-CT-010': 'Debug',
  'TA-3-CT-013': 'Variables',
  'TA-3-CT-016': 'Loops & Conditionals',
  'TA-3-CI-001': 'Design Skills',
  'TA-3-CI-004': 'Design Process',
  'TA-3-CI-007': 'Emerging Tech',
  'TA-3-DL-001': 'Collect Numerical Data',
  'TA-3-DL-004': 'Search Strategies',
  'TA-3-DL-007': 'Analyze Data',
  'TA-3-DL-010': 'Communicate Results',
  'TA-3-DC-001': 'Digital Footprint',
  'TA-3-DC-004': 'Digital Etiquette',
  'TA-3-DC-007': 'Digital Collaboration',
  'TA-3-DC-010': 'AUP',
  'TA-3-DC-013': 'Copyright',
  'TA-3-DC-016': 'Citations',
  'TA-3-DC-019': 'Account Safety',
  'TA-3-DC-022': 'Safe Practices',
  'TA-3-DC-025': 'Cyberbullying',
  'TA-3-PT-001': 'Compare Applications',
  'TA-3-PT-004': 'Software Functions',
  'TA-3-PT-007': 'Network Terminology',
  'TA-3-PT-010': 'File Management',
  'TA-3-PT-013': 'Keyboarding',
  'TA-3-PT-016': 'Keyboard Shortcuts',
  'TA-3-PT-019': 'Troubleshooting',

  // ── Grade 4 ───────────────────────────────────────────────────────────────
  'TA-4-CT-001': 'Decomposition',
  'TA-4-CT-004': 'Pattern Recognition',
  'TA-4-CT-007': 'Abstraction',
  'TA-4-CT-010': 'Algorithm Design',
  'TA-4-CT-013': 'Debugging',
  'TA-4-CT-016': 'Data',
  'TA-4-CT-019': 'Automation',
  'TA-4-DC-001': 'Privacy & Personal Info',
  'TA-4-DC-004': 'Cyberbullying',
  'TA-4-DC-007': 'Digital Footprint',
  'TA-4-DC-010': 'Responsible Use',
  'TA-4-DC-013': 'Copyright',
  'TA-4-CC-001': 'Digital Tools',
  'TA-4-CC-004': 'Audience & Purpose',
  'TA-4-CC-007': 'Online Etiquette',
  'TA-4-CC-010': 'Presenting',
  'TA-4-RI-001': 'Search Strategies',
  'TA-4-RI-004': 'Evaluating Sources',
  'TA-4-RI-007': 'Organizing Information',
  'TA-4-RI-010': 'Citing Sources',
  'TA-4-CI-001': 'Digital Artifacts',
  'TA-4-CI-004': 'Sequences',
  'TA-4-CI-007': 'Loops',
  'TA-4-CI-010': 'Conditionals',
  'TA-4-CI-013': 'Variables',

  // ── Grade 5 ───────────────────────────────────────────────────────────────
  'TA-5-CT-001': '5.1A · Decompose Problems',
  'TA-5-CT-004': '5.1B · Identify Patterns',
  'TA-5-CT-007': '5.1C · Document Plans',
  'TA-5-CT-010': '5.1D · Debug Algorithms',
  'TA-5-CT-013': '5.2A · Variables',
  'TA-5-CT-016': '5.2B · Programs',
  'TA-5-CI-001': '5.3A · Design Skills',
  'TA-5-CI-004': '5.3B · Design Process',
  'TA-5-CI-007': '5.4A · Emerging Tech Impact',
  'TA-5-CI-010': '5.4B · Evaluate Emerging Tech',
  'TA-5-DL-001': '5.5A · Collect Data',
  'TA-5-DL-004': '5.5B · Search Strategies',
  'TA-5-DL-007': '5.6A · Identify Data Type',
  'TA-5-DL-010': '5.6B · Analyze Data',
  'TA-5-DL-013': '5.6C · Communicate Results',
  'TA-5-DC-001': '5.7A · Digital Footprint',
  'TA-5-DC-004': '5.7B · Privacy',
  'TA-5-DC-007': '5.8A · Digital Etiquette',
  'TA-5-DC-010': '5.8B · Collaboration',
  'TA-5-DC-013': '5.9A · Copyright',
  'TA-5-DC-016': '5.9B · Citations',
  'TA-5-DC-019': '5.10A · Account Safety',
  'TA-5-DC-022': '5.10B · Cyberbullying',
  'TA-5-PT-001': '5.11A · Compare Software',
  'TA-5-PT-004': '5.11B · Apply Software',
  'TA-5-PT-007': '5.12A · Network Components',
  'TA-5-PT-010': '5.12B · Data Transmission',
  'TA-5-PT-013': '5.13A · File Management',
  'TA-5-PT-016': '5.13B · Keyboard Shortcuts',

  // ── Grade 6 ───────────────────────────────────────────────────────────────
  'TA-6-CT-001': '6.1A · Decompose Problems',
  'TA-6-CT-004': '6.1B · Identify Patterns',
  'TA-6-CT-007': '6.1C · Design Algorithms',
  'TA-6-CT-010': '6.1D · Debug Algorithms',
  'TA-6-CT-013': '6.2A · Variables',
  'TA-6-CT-016': '6.2B · Programs',
  'TA-6-CI-001': '6.3A · Design Thinking',
  'TA-6-CI-004': '6.3B · Evaluate & Iterate',
  'TA-6-CI-007': '6.4A · Emerging Tech',
  'TA-6-DL-001': '6.5A · Collect Data',
  'TA-6-DL-004': '6.5B · Source Credibility',
  'TA-6-DL-007': '6.6A · Organize Data',
  'TA-6-DL-010': '6.6B · Manage Data',
  'TA-6-DL-013': '6.6C · Analyze Data',
  'TA-6-DC-001': '6.7A · Digital Footprint',
  'TA-6-DC-004': '6.7B · Privacy',
  'TA-6-DC-007': '6.8A · Digital Etiquette',
  'TA-6-DC-010': '6.8B · Collaboration',
  'TA-6-DC-013': '6.9A · Copyright',
  'TA-6-DC-016': '6.9B · Citations',
  'TA-6-DC-019': '6.10A · Account Security',
  'TA-6-DC-022': '6.10B · Cyberbullying',
  'TA-6-PT-001': '6.11A · Evaluate Apps',
  'TA-6-PT-004': '6.11B · Apply Software',
  'TA-6-PT-007': '6.12A · Networks',
  'TA-6-PT-010': '6.12B · Data Transmission',
  'TA-6-PT-013': '6.13A · File Management',
  'TA-6-PT-016': '6.13B · Keyboarding',
  'TA-6-PT-019': '6.13C · Troubleshooting',

  // ── Grade 7 ───────────────────────────────────────────────────────────────
  'TA-7-CT-001': '7.1A · Decompose Problems',
  'TA-7-CT-004': '7.1B · Patterns & Abstraction',
  'TA-7-CT-007': '7.1C · Design Algorithms',
  'TA-7-CT-010': '7.1D · Debug & Test',
  'TA-7-CT-013': '7.2A · Variables & Functions',
  'TA-7-CT-016': '7.2B · Programs',
  'TA-7-CI-001': '7.3A · Design Process',
  'TA-7-CI-004': '7.3B · Evaluate & Iterate',
  'TA-7-CI-007': '7.4A · Emerging Tech',
  'TA-7-CI-010': '7.4B · Tech & Society',
  'TA-7-DL-001': '7.5A · Collect Data',
  'TA-7-DL-004': '7.5B · Credibility & Bias',
  'TA-7-DL-007': '7.6A · Organize Data',
  'TA-7-DL-010': '7.6B · Manage & Secure Data',
  'TA-7-DL-013': '7.6C · Analyze & Communicate',
  'TA-7-DC-001': '7.7A · Digital Footprint',
  'TA-7-DC-004': '7.7B · Privacy & Consent',
  'TA-7-DC-007': '7.8A · Professional Communication',
  'TA-7-DC-010': '7.8B · Collaboration',
  'TA-7-DC-013': '7.9A · Copyright',
  'TA-7-DC-016': '7.9B · Citations',
  'TA-7-DC-019': '7.10A · Account Security',
  'TA-7-DC-022': '7.10B · Cyberbullying',
  'TA-7-PT-001': '7.11A · Evaluate Apps',
  'TA-7-PT-004': '7.11B · Advanced Software',
  'TA-7-PT-007': '7.12A · Networks & Security',
  'TA-7-PT-010': '7.12B · Cloud Computing',
  'TA-7-PT-013': '7.13A · File Management',
  'TA-7-PT-016': '7.13B · Keyboarding',

  // ── Grade 8 ───────────────────────────────────────────────────────────────
  'TA-8-CT-001': '8.1A · Decompose Problems',
  'TA-8-CT-004': '8.1B · Identify Patterns',
  'TA-8-CT-007': '8.1C · Design Plans',
  'TA-8-CT-010': '8.1D · Debug Algorithms',
  'TA-8-CT-013': '8.2A · Variables & Functions',
  'TA-8-CT-016': '8.2B · Complex Programs',
  'TA-8-CI-001': '8.3A · Design Process',
  'TA-8-CI-004': '8.3B · Evaluate & Iterate',
  'TA-8-CI-007': '8.4A · Impact on Society',
  'TA-8-CI-010': '8.4B · Impact on Economy',
  'TA-8-CI-013': '8.4C · Impact on Culture',
  'TA-8-DL-001': '8.5A · Collect Data',
  'TA-8-DL-004': '8.5B · Source Credibility',
  'TA-8-DL-007': '8.6A · Organize Data',
  'TA-8-DL-010': '8.6B · Manage Data',
  'TA-8-DL-013': '8.6C · Analyze Data',
  'TA-8-DL-016': '8.7A · Data Visualizations',
  'TA-8-DL-019': '8.7B · Publish Reports',
  'TA-8-DC-001': '8.8A · Digital Footprint',
  'TA-8-DC-004': '8.8B · Etiquette & Collaboration',
  'TA-8-DC-007': '8.9A · Copyright & Citation',
  'TA-8-DC-010': '8.10A · Account Security',
  'TA-8-DC-013': '8.10B · Cyberbullying',
  'TA-8-PT-001': '8.11A · Evaluate Apps',
  'TA-8-PT-004': '8.11B · Advanced Functions',
  'TA-8-PT-007': '8.12A · Networks',
  'TA-8-PT-010': '8.12B · File Management',
  'TA-8-PT-013': '8.12C · Keyboarding',
  'TA-8-PT-016': '8.12D · Troubleshooting',
};

export function buildStandards(questions) {
  const strandOrder = [];
  const strandMap = {};

  for (const q of questions) {
    if (!strandMap[q.strand]) {
      strandMap[q.strand] = [];
      strandOrder.push(q.strand);
    }
    strandMap[q.strand].push(q);
  }

  return strandOrder.map(strand => {
    const qs = strandMap[strand];
    const standards = [];
    for (let i = 0; i < qs.length; i += 3) {
      const group = qs.slice(i, i + 3);
      standards.push({
        id: group[0].id,
        label: STANDARD_LABELS[group[0].id] ?? group[0].id,
        questions: group,
      });
    }
    return { strand, standards };
  });
}
